import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { tasks_company_path } from "../routes"

export default class extends Controller {
  static values = {
    companyId: String
  }
  
  static targets = [
    "showAllTasks",
    "sortColumn",
    "sortDirection"
  ]

  // Company tasks filter controller
  // Handles filtering and sorting of company tasks via turbo stream

  submit(event) {
    event.preventDefault()
    
    // Get the controller instance for the element that triggered the event
    // This handles cases where there are multiple instances (desktop/mobile)
    const controllerElement = event.target.closest('[data-controller*="company-tasks-filter"]')
    if (!controllerElement) return
    
    // Find targets within the same controller scope
    const showAllTasksEl = controllerElement.querySelector('[data-company-tasks-filter-target="showAllTasks"]')
    const sortColumnEl = controllerElement.querySelector('[data-company-tasks-filter-target="sortColumn"]')
    const sortDirectionEl = controllerElement.querySelector('[data-company-tasks-filter-target="sortDirection"]')
    
    // Build params from current DOM state using targets
    const params = {
      show_all_tasks: showAllTasksEl?.checked ? 'true' : 'false',
      task_sort_column: sortColumnEl?.value || 'created_at',
      task_sort_direction: sortDirectionEl?.value || 'desc'
    }
    
    // Get company ID from the controller element
    const companyId = controllerElement.dataset.companyTasksFilterCompanyIdValue
    if (!companyId) return

    // Build URL with query parameters using js-routes
    const url = new URL(tasks_company_path({ id: companyId }), window.location.origin)
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        url.searchParams.set(key, params[key])
      }
    })

    // Make request with Turbo
    fetch(url.toString(), {
      method: 'GET',
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ''
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.text()
    })
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Error in company-tasks-filter:', error)
    })
  }
}

